import type { StockHolderNumberPoint, StockHolderTradeRow } from "fin-web-components";
import { useLongfansMock } from "../../global/GlobalMock";
import { post } from "../../utils/Backend";
import { mockStockHolderNumbers, mockStockHolderTrades } from "./StockHolderMock";

export interface QueryStockHolderNumbersParam {
  stockCode: string;
  size?: number;
}

export interface QueryStockHolderTradesParam {
  stockCode: string;
  limit?: number;
}

const QUERY_HOLDER_NUMBERS_URL = "/lark/app/stock/queryStockHolderNumbers";
const QUERY_HOLDER_TRADES_URL = "/lark/app/stock/queryStockHolderTrades";

const StockHolderApi = {
  async queryStockHolderNumbers(
    stockCode: string,
    size = 120
  ): Promise<StockHolderNumberPoint[]> {
    const code = stockCode.trim();
    if (!code) {
      return [];
    }
    if (useLongfansMock) {
      return mockStockHolderNumbers(code, size);
    }
    const r = await post<QueryStockHolderNumbersParam, StockHolderNumberPoint[]>(
      QUERY_HOLDER_NUMBERS_URL,
      { stockCode: code, size }
    );
    if (typeof r === "string" || !Array.isArray(r)) {
      return [];
    }
    return r;
  },

  async queryStockHolderTrades(
    stockCode: string,
    limit = 20
  ): Promise<StockHolderTradeRow[]> {
    const code = stockCode.trim();
    if (!code) {
      return [];
    }
    if (useLongfansMock) {
      return mockStockHolderTrades(code, limit);
    }
    const r = await post<QueryStockHolderTradesParam, StockHolderTradeRow[]>(
      QUERY_HOLDER_TRADES_URL,
      { stockCode: code, limit }
    );
    if (typeof r === "string" || !Array.isArray(r)) {
      return [];
    }
    return r.map((row) => ({
      annDate: String(row.annDate ?? ""),
      holderName: row.holderName,
      inDe: row.inDe,
      changeVol: row.changeVol,
      changeRatio: row.changeRatio,
      avgPrice: row.avgPrice,
    }));
  },
};

export default StockHolderApi;
